import React from 'react';
import { Tab, Tabs, Container } from 'react-bootstrap';
import styles from './HedefFormu.module.css';
import YayinlarCard from './components/cards/YayinlarCard';
import KitaplarCard from './components/cards/KitaplarCard';
import EtkinliklerCard from './components/cards/EtkinliklerCard';
import ProjelerCard from './components/cards/ProjelerCard';
import PatentCard from './components/cards/PatentCard';

const HedefFormu = () => {
  const academic = {
    title: "Dr. Öğr. Üyesi",
    name: "Lorem Ipsum",
    faculty: "Mühendislik Fakültesi",
    department: "Bilgisayar Mühendisliği",
    division: "Yazılım Anabilim Dalı"
  };

  const data = {
    yayinlar: {
      q1: 3,
      q2: 2,
      q3: 1,
      q4: 2,
      esci: 2,
      uluslararasiAlanIndeks: 1,
      trDizin: 2
    },
    kitaplar: {
      ulusalYazarlik: 2,
      uluslararasiYazarlik: 1,
      bkciYazarlik: 1,
      ulusalBolum: 3,
      uluslararasiBolum: 2,
      bkciBolum: 1,
      ulusalEditorluk: 1,
      uluslararasiEditorluk: 1,
      bkciEditorluk: 0
    },
    etkinlikler: {
      ulusalKongre: 2,
      uluslararasiKongre: 1,
      ulusalSempozyum: 1,
      uluslararasiSempozyum: 2,
      ulusalCalistay: 1,
      uluslararasiCalistay: 1,
      ulusalPanel: 1,
      uluslararasiPanel: 1
    },
    projeler: {
      horizonEuropeYurutucu: 1,
      horizonEuropeArastirmaci: 2,
      tubitak1001Yurutucu: 1,
      tubitak1001Arastirmaci: 2,
      bapYurutucu: 2,
      bapArastirmaci: 3
    },
    patent: {
      ulusalPatent: 1,
      uluslararasiPatent: 1,
      ulusalTasarim: 2,
      uluslararasiTasarim: 0,
      ulusalFaydaliModel: 1,
      uluslararasiFaydaliModel: 0
    }
  };

  return (
    <Container className={styles.wrapper}>
      <div className={styles.academicHeader}>
        <div className={styles.academicTitle}>
          {academic.title} {academic.name}
        </div>
        <div className={styles.academicInfo}>
          <div>{academic.faculty}</div>
          <div>{academic.department} / {academic.division}</div>
        </div>
      </div>

      <div className={styles.tabContainer}>
        <Tabs
          defaultActiveKey="yayinlar"
          className={styles.customTabs}
          fill
        >
          <Tab eventKey="yayinlar" title="Yayınlar">
            <div className={styles.tabContent}>
              <YayinlarCard data={data.yayinlar} onEdit={() => {}} />
            </div>
          </Tab>
          <Tab eventKey="kitaplar" title="Kitaplar">
            <div className={styles.tabContent}>
              <KitaplarCard data={data.kitaplar} onEdit={() => {}} />
            </div>
          </Tab>
          <Tab eventKey="etkinlikler" title="Etkinlikler">
            <div className={styles.tabContent}>
              <EtkinliklerCard data={data.etkinlikler} onEdit={() => {}} />
            </div>
          </Tab>
          <Tab eventKey="projeler" title="Projeler">
            <div className={styles.tabContent}>
              <ProjelerCard data={data.projeler} onEdit={() => {}} />
            </div>
          </Tab>
          <Tab eventKey="patent" title="Patent/Tasarım">
            <div className={styles.tabContent}>
              <PatentCard data={data.patent} onEdit={() => {}} />
            </div>
          </Tab>
        </Tabs>
      </div>
    </Container>
  );
};

export default HedefFormu;